/* 
    The currency format for amounts that can be simplified to just their integer part.
    e.g £1.00 => £1
*/
export const currencyFormatInteger = new Intl.NumberFormat(
  process.env.GATSBY_LOCALE,
  {
    style: "currency",
    currency: process.env.GATSBY_CURRENCY,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }
);

/*
    The currency format for amounts that cannot be simplified to just their integer part.
    i.e those that have a non-zero decimal part.
    e.g £1.5 => £1.50;
*/
export const currencyFormatDecimal = new Intl.NumberFormat(
  process.env.GATSBY_LOCALE,
  {
    style: "currency",
    currency: process.env.GATSBY_CURRENCY,
    minimumFractionDigits: 2,
  }
);

/*
  Retrieves the currency format for the specified value with custom options applied on top of the defaults.
*/
export const getCurrencyFormatWithOptions = (
  inputValue: number,
  options: Intl.NumberFormatOptions,
): Intl.NumberFormat => {
  const integerFormat: Intl.NumberFormatOptions = {
    style: "currency",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  };

  const decimalFormat: Intl.NumberFormatOptions = {
    style: "currency",
    minimumFractionDigits: 2,
  };

  const formatOptions = inputValue % 1 == 0 ? integerFormat : decimalFormat;

  const newOptions = {
    ...formatOptions,
    options,
  };

  return new Intl.NumberFormat(process.env.GATSBY_LOCALE, newOptions);
};

/*
    Retrieves the currency format for the specified value.
*/
export const getCurrencyFormat = (inputValue: number): Intl.NumberFormat =>
  inputValue % 1 == 0 ? currencyFormatInteger : currencyFormatDecimal;

/*
    Retrieves and applies the currency format for the specified value.
*/
export const applyCurrencyFormat = (inputValue: number): string =>
  getCurrencyFormat(inputValue).format(inputValue);
